"use client";

import * as React from "react";

import classNames from "classnames";

import { usePlasmicQueryData } from "@stadium/services/plasmic";

import { fetchPlasmicCMSData } from "@stadium/shared/src/helpers/plasmic/cms-api";

import { BE05_TABLE_ID, CMS_FIELDS, CMS_SECTION_FIELDS } from "./constants";

import BlogCardsBase from "@stadium/shared/src/components/plasmic/BlogEntry/blog-cards-base";

import styles from "./main.module.scss";

export interface BE05Props {
  className?: string;
}

const BE05: React.FC<Readonly<BE05Props>> = ({ className }) => {
  const { data, isLoading } = usePlasmicQueryData([BE05_TABLE_ID], async () => {
    const data = await fetchPlasmicCMSData({ tableId: BE05_TABLE_ID });
    if (!data) return null;

    return {
      heading: data[CMS_SECTION_FIELDS.HEADING] || "",
      cards: (data[CMS_SECTION_FIELDS.CARD] || []).map((item: any) => ({
        image: item[CMS_FIELDS.IMAGE]?.url,
        imageAlt: item[CMS_FIELDS.TITLE] || "",
        title: item[CMS_FIELDS.TITLE],
        description: item[CMS_FIELDS.DESCRIPTION],
      })),
    };
  });

  if (isLoading) return null;
  if (!data) return null;

  return (
    <section className={classNames(styles.sectionWrapper, className)}>
      <div className={styles.divWrapper}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{data.heading}</h2>
        </div>
        {/* Cards */}
        <BlogCardsBase variant="BE05" cards={data.cards} styles={styles} />
      </div>
    </section>
  );
};

export default BE05;
